import { useTranslation } from 'react-i18next';
import { ConfirmationPrompt } from '../../../../../components/ConfirmationPrompt';
import { useDeleteInvitationGroup } from './deleteInvitationGroupPanel/utility/useDeleteInvitationGroup';

const DeleteInvitationGroupPanel = ({
  selectedInvitationGroupKey,
  setSelectedInvitationGroupKey,
}) => {
  const { t: translator } = useTranslation();
  const { isPopupOpen, setIsPopupOpen, onConfirm } = useDeleteInvitationGroup(
    selectedInvitationGroupKey,
    setSelectedInvitationGroupKey,
  );

  return (
    <ConfirmationPrompt
      isOpen={isPopupOpen}
      onDismiss={() => setIsPopupOpen(false)}
      onConfirm={onConfirm}
      text={translator(
        'pages.adminInvitationGroups.deleteInvitationGroupPanel.prompt',
      )}
    />
  );
};

export { DeleteInvitationGroupPanel };
